class NumberInput {
	stateClasses = {
		disabled: 'number-input__button--disabled',
	};
	constructor($el) {
		this.$el = $el;
		this.$input = $el.find('[data-number="input"]');
		this.$remove = $el.find('[data-number="remove"]');
		this.$add = $el.find('[data-number="add"]');
		this.value = parseInt(this.$input.val());

		this.init();
	}

	init = () => {
		this.checkDecrement();
		this.$add.on('click', this.increment);
		this.$remove.on('click', this.decrement);
	};

	increment = () => {
		this.value++;
		this.$input.val(this.value);
		this.checkDecrement();
		this.$el.trigger('update-input', [this.value]);
	};

	decrement = () => {
		this.value--;
		this.$input.val(this.value);
		this.checkDecrement();
		this.$el.trigger('update-input', [this.value]);
	};

	checkDecrement = () => {
		if (this.value <= 0) {
			this.$remove.addClass(this.stateClasses.disabled);
		} else {
			this.$remove.removeClass(this.stateClasses.disabled);
		}
	};
}

export default NumberInput;
